import { api, tokenStore } from "./client";
import type {
  LoginPayload,
  LoginResult,
  LoginResultSuccess,
  MfaEnrolStartResponse,
  User,
} from "@/types/auth";

export async function login(payload: LoginPayload): Promise<LoginResult> {
  const res = await api.post<LoginResult>("/auth/login", payload);
  if ("accessToken" in res.data) {
    tokenStore.write(res.data);
  }
  return res.data;
}

export async function verifyMfa(args: {
  mfaSession: string;
  code: string;
}): Promise<LoginResultSuccess> {
  const res = await api.post<LoginResultSuccess>("/auth/mfa", args);
  tokenStore.write(res.data);
  return res.data;
}

export async function startMfaEnrolment(args: {
  mfaSession: string;
}): Promise<MfaEnrolStartResponse> {
  const res = await api.post<MfaEnrolStartResponse>(
    "/auth/mfa/enrol/start",
    args
  );
  return res.data;
}

export async function confirmMfaEnrolment(args: {
  mfaSession: string;
  code: string;
}): Promise<LoginResultSuccess> {
  const res = await api.post<LoginResultSuccess>(
    "/auth/mfa/enrol/confirm",
    args
  );
  tokenStore.write(res.data);
  return res.data;
}

export async function getMe(): Promise<{ user: User; serverTime: string }> {
  const res = await api.get<{ user: User; serverTime: string }>("/auth/me");
  return res.data;
}

export async function logout(): Promise<void> {
  const tokens = tokenStore.read();
  await api.post("/auth/logout", { refreshToken: tokens?.refreshToken ?? null });
  tokenStore.clear();
}
